module.exports = __webpack_public_path__ + "img/stop_btn.20a65468.png";